<template>
<div class="spot-pink">
  <div class="tv-animation">
    <img src="~@/assets/img/spot-pink-1.png" alt="Frame 1" />
    <img src="~@/assets/img/spot-pink-2.png" alt="Frame 2"/>
    <img src="~@/assets/img/spot-pink-3.png" alt="Frame 3"/>
    <img src="~@/assets/img/spot-pink-4.png" alt="Frame 4"/>
    <img src="~@/assets/img/spot-pink-5.png" alt="Frame 5"/>
    <img src="~@/assets/img/spot-pink-6.png" alt="Frame 6" />
    <img src="~@/assets/img/spot-pink-7.png" alt="Frame 7"/>
    <img src="~@/assets/img/spot-pink-8.png" alt="Frame 8"/>
    <img src="~@/assets/img/spot-pink-9.png" alt="Frame 9"/>
    <img src="~@/assets/img/spot-pink-10.png" alt="Frame 10"/>
    <img src="~@/assets/img/spot-pink-11.png" alt="Frame 11" />
    <img src="~@/assets/img/spot-pink-12.png" alt="Frame 12"/>
    <img src="~@/assets/img/spot-pink-13.png" alt="Frame 13"/>
    <img src="~@/assets/img/spot-pink-14.png" alt="Frame 14"/>
    <img src="~@/assets/img/spot-pink-15.png" alt="Frame 15"/>
    <img src="~@/assets/img/spot-pink-16.png" alt="Frame 16" />
    <img src="~@/assets/img/spot-pink-17.png" alt="Frame 17"/>
    <img src="~@/assets/img/spot-pink-18.png" alt="Frame 18"/>
    <img src="~@/assets/img/spot-pink-19.png" alt="Frame 19"/>
    <img src="~@/assets/img/spot-pink-20.png" alt="Frame 20"/>
    <img src="~@/assets/img/spot-pink-21.png" alt="Frame 21" />
    <img src="~@/assets/img/spot-pink-22.png" alt="Frame 22"/>
    <img src="~@/assets/img/spot-pink-23.png" alt="Frame 23"/>
    <img src="~@/assets/img/spot-pink-24.png" alt="Frame 24"/>
    <img src="~@/assets/img/spot-pink-25.png" alt="Frame 25"/>
    <img src="~@/assets/img/spot-pink-26.png" alt="Frame 26" />
    <img src="~@/assets/img/spot-pink-27.png" alt="Frame 27"/>
  </div>

</div>
</template>

<script>
export default {
  name: "spot-pink", 
};
</script>

<style lang="scss">
@keyframes play-pink {
  0%,
  4% {
    background-image: url("~@/assets/img/spot-pink-1.png");
  }
  4%,
  8% {
    background-image: url("~@/assets/img/spot-pink-2.png");
  }
  8%,
  12% {
    background-image: url("~@/assets/img/spot-pink-3.png");
  }
  12%,
  16% {
    background-image: url("~@/assets/img/spot-pink-4.png");
  }
  16%,
  20% {
    background-image: url("~@/assets/img/spot-pink-4.png");
  }
  20%,
  24% {
    background-image: url("~@/assets/img/spot-pink-5.png");
  }
  24%,
  28% {
    background-image: url("~@/assets/img/spot-pink-5.png");
  }
  28%,
  32% {
    background-image: url("~@/assets/img/spot-pink-6.png");
  }
  32%,
  36% {
    background-image: url("~@/assets/img/spot-pink-7.png");
  }
  36%,
  40% {
    background-image: url("~@/assets/img/spot-pink-8.png");
  }
  40%,
  44% {
    background-image: url("~@/assets/img/spot-pink-9.png");
  }
  44%,
  48% {
    background-image: url("~@/assets/img/spot-pink-10.png");
  }
  48%,
  52% {
    background-image: url("~@/assets/img/spot-pink-11.png");
  }
  52%,
  56% {
    background-image: url("~@/assets/img/spot-pink-12.png");
  }
  56%,
  60% {
    background-image: url("~@/assets/img/spot-pink-13.png");
  }
  60%,
  64% {
    background-image: url("~@/assets/img/spot-pink-15.png");
  }
  64%,
  68% {
    background-image: url("~@/assets/img/spot-pink-16.png");
  }
  68%,
  72% {
    background-image: url("~@/assets/img/spot-pink-18.png");
  }
  72%,
  76% {
    background-image: url("~@/assets/img/spot-pink-19.png");
  }
  76%,
  80% {
    background-image: url("~@/assets/img/spot-pink-20.png");
  }
  80%,
  84% {
    background-image: url("~@/assets/img/spot-pink-21.png");
  }
  84%,
  88% {
    background-image: url("~@/assets/img/spot-pink-22.png");
  }
  88%,
  92% {
    background-image: url("~@/assets/img/spot-pink-23.png");
  }
  92%,
  96% {
    background-image: url("~@/assets/img/spot-pink-25.png");
  }
  96%,
  100% {
    background-image: url("~@/assets/img/spot-pink-26.png");
  }
}

.active {
  .tv-pink {
    .tv-animation {
    animation: play-pink 21s step-start;
    background-size: cover;
    background-image: url("~@/assets/img/spot-pink-1.png");
    }
  }
}
 
.tv-pink {

  .tv-animation {
      position: absolute;
      background-repeat: no-repeat;

      img {
        display: none;
      }
  }
}


</style>